export class DirectorResponseAddCommand {
    constructor(
        public readonly VarianceId: string,
        public readonly Text: string,
        public readonly AddedBy: string,
    ) {}
}
